import { render, staticRenderFns } from "./flashing-display-config.vue?vue&type=template&id=47cf160b&"
import script from "./flashing-display-config.vue?vue&type=script&lang=js&"
export * from "./flashing-display-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports